import PropTypes from 'prop-types';
import {
  MasterListHeaderWrapper,
  MasterListHeaderFilterWrapper,
  MasterListHeaderFilterItemWrapper,
  MasterListHeaderFilterItem,
  MasterListHeaderCreateMasterListButton,
} from './MasterListHeader.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const MasterListHeader = ({
  showCreateMasterListBtn,
  stringsData,
  selectedStatusFilter,
  masterListStatusFilterList,
  handleMasterListStatusFilterClick,
  handelAddMasterListBtnClick,
}) => (
  <MasterListHeaderWrapper>
    <MasterListHeaderFilterWrapper>
      {masterListStatusFilterList &&
        masterListStatusFilterList.map(masterListFilterItem => {
          const isFilterSelected = masterListFilterItem.key === selectedStatusFilter.key;

          return (
            <MasterListHeaderFilterItemWrapper
              key={masterListFilterItem.key}
              selected={isFilterSelected}
              onClick={() => handleMasterListStatusFilterClick(masterListFilterItem)}
            >
              <MasterListHeaderFilterItem>{masterListFilterItem.name}</MasterListHeaderFilterItem>
            </MasterListHeaderFilterItemWrapper>
          );
        })}
    </MasterListHeaderFilterWrapper>
    {showCreateMasterListBtn && (
      <MasterListHeaderCreateMasterListButton
        as="button"
        onClick={() => handelAddMasterListBtnClick(true)}
      >
        {stringsData.masterListHeader.createMasterListButton}
      </MasterListHeaderCreateMasterListButton>
    )}
  </MasterListHeaderWrapper>
);
MasterListHeader.propTypes = {
  showCreateMasterListBtn: PropTypes.bool,
  stringsData: PropTypes.shape({
    masterListHeader: PropTypes.shape({
      allMasterListFilterItem: PropTypes.string,
      createMasterListButton: PropTypes.string,
    }),
  }).isRequired,
  selectedStatusFilter: PropTypes.shape({
    key: PropTypes.number,
  }),
  masterListStatusFilterList: PropTypes.arrayOf(PropTypes.shape({})),
  handleMasterListStatusFilterClick: PropTypes.func,
  handelAddMasterListBtnClick: PropTypes.func,
};

MasterListHeader.defaultProps = {
  showCreateMasterListBtn: true,
  selectedStatusFilter: {},
  masterListStatusFilterList: [],
  handleMasterListStatusFilterClick: () => {},
  handelAddMasterListBtnClick: () => {},
};

export default MasterListHeader;
